// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"75af37e0","195":"81c6da4a"}[chunkId] + ".chunk.js";
};